import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Star } from 'lucide-react';
export function CostOfInaction() {
  const whyChoose = ['Colección completa y organizada.', 'Contenido claro y fácil de comprender.', 'Ideal para descubrir desde cero.', 'Material pensado para todas las edades.', 'Lectura entretenida y dinámica.', 'Acceso inmediato.', 'Acceso de por vida.'];
  const whoIsItFor = ['Siempre te fascinó la mitología griega.', 'Te apasiona la historia antigua.', 'Disfrutas descubrir por curiosidad.', 'Buscas ampliar tu cultura general.', 'Eres estudiante, docente o amante del conocimiento.', 'Quieres compartir contenido educativo con tu familia.'];
  return <section className="py-20 md:py-32 px-4" data-id="element-29">
      <div className="max-w-6xl mx-auto" data-id="element-30">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16" data-id="element-31">
          {/* Why Choose */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-32">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-8" data-id="element-33">
              ¿Por qué elegir Grecia Legendaria?
            </h2>
            <div className="space-y-4" data-id="element-34">
              {whyChoose.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-35">
                  <CheckCircle2 className="w-6 h-6 text-gold shrink-0" data-id="element-36" />
                  <p className="text-gray-300 text-lg" data-id="element-37">{item}</p>
                </div>)}
            </div>
          </motion.div>

          {/* Who is it for */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-38">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-8" data-id="element-39">
              Este MegaPack es ideal si...
            </h2>
            <p className="text-xl text-gold-light mb-6" data-id="element-40">
              Es perfecto para ti si:
            </p>
            <div className="space-y-4" data-id="element-41">
              {whoIsItFor.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-42">
                  <Star className="w-6 h-6 text-gold shrink-0" data-id="element-43" />
                  <p className="text-gray-300 text-lg" data-id="element-44">{item}</p>
                </div>)}
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-20 text-center bg-dark-card border border-dark-border p-8 md:p-12 rounded-2xl" data-id="element-45">
          <h3 className="text-2xl md:text-4xl font-heading font-bold text-white mb-6" data-id="element-46">
            ¿Qué hace diferente a Grecia Legendaria?
          </h3>
          <p className="text-lg md:text-xl text-gray-300 mb-6 max-w-3xl mx-auto" data-id="element-47">
            Grecia Legendaria no fue creada como un libro escolar. Fue diseñada
            para que descubras una de las civilizaciones más fascinantes de la
            historia mediante relatos, curiosidades y contenido organizado que
            hacen del descubrimiento una experiencia entretenida y accesible.
          </p>
          <p className="text-xl md:text-2xl text-gold-light font-bold max-w-3xl mx-auto" data-id="element-48">
            Cada módulo te permitirá comprender el origen de los grandes mitos,
            conocer a los dioses y héroes más famosos, explorar los misterios de
            la Antigua Grecia y descubrir el enorme legado que sigue presente en
            nuestra cultura.
          </p>
        </motion.div>
      </div>
    </section>;
}